<nav class="navbar navbar-expand box-shadow">
  <a class="navbar-brand">SMART E-TAX</a>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto"></ul>
    <ul class="navbar-nav align-middle">
      <div ngbDropdown placement="bottom-right" id="userArea" class="d-inline-block align-middle text-white">
        <select class="form-control form-control-sm language-switcher" style="vertical-align: middle;
          width: auto; height: auto ;display: inline" (change)="changeLanguage()" [(ngModel)]="language">
          <option value="en">&nbsp;EN</option>
          <option value="th">&nbsp;TH</option>
        </select>
      </div>
    </ul>
  </div>
</nav>
<div class="container">
  <div class="row mt-3">
    <div class="col-12">
      <h3 class="text-center">
        {{ 'CUSTOMER-REQUEST.TAX-INVOICE-REQUEST' | translate}}
      </h3>
    </div>
  </div>
  <div [formGroup]="buyerRequestForm" class="position-relative row">
    <div class="col-md-6 mt-3">
      <div class="box-content">
        <h4 class="title">
          {{ 'CUSTOMER-REQUEST.REQUEST-DETAIL' | translate}}
        </h4>
      </div>
      <div class="box-content mt-3 box-content-size">
        <div class="row">
          <h5 class="title ml-3">
            {{ 'CUSTOMER-REQUEST.BILL-DETAIL' | translate}}
          </h5>
        </div>

        <div class="mt-2">
          <p-radioButton class="dv-checkbox"
              name="type"
              value="hotel"
              inputID="type_hotel"
              label="{{ 'CUSTOMER-REQUEST.HOTEL-ROOM' | translate}}"
              formControlName="type">
          </p-radioButton>
          <p-radioButton class="dv-checkbox ml-4"
              name="type"
              value="dinning"
              inputID="type_dinning"
              label="{{ 'CUSTOMER-REQUEST.DINNING-ROOM' | translate}}"
              formControlName="type">
          </p-radioButton>
        </div>
        <div>
          <div class="row">
            <div class="col-12">
              <label class="required" *ngIf="form.type.value === 'dinning'" for="abb-no">
                {{ 'CUSTOMER-REQUEST.CHK-NO' | translate }}
              </label>
              <label class="required" *ngIf="form.type.value === 'hotel'" for="abb-no">
                {{ 'TABLE.ABB-NO' | translate}}
              </label>
            </div>
            <div class="col-12">
              <input class="form-control" type="text" id="abb-no" formControlName="abbNo">
              <div *ngIf="form.abbNo.errors?.required && showError">
                <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
              </div>
            </div>
            <div class="col-6 mt-2">
              <label class="required" for="receipt-issue-date">
                {{ 'CUSTOMER-REQUEST.RECEIPT-ISSUE-DATE' | translate}}
              </label>
            </div>
            <div class="col-6 mt-2">
              <label class="required"
                  for="amount">
                {{ 'CUSTOMER-REQUEST.AMOUNT' | translate}}
              </label>
            </div>
            <div class="col-6">
              <p-calendar id="receipt-issue-date" formControlName="receiptIssueDate" readonlyInput="true" [showIcon]="true"
                dateFormat="dd/mm/yy" [locale]="calendarLocale" [yearNavigator]="true" yearRange="2000:2030">
              </p-calendar>
              <div *ngIf="form.receiptIssueDate.errors?.required && showError">
                <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
              </div>
            </div>
            <div class="col-6">
              <input class="form-control text-right"
                  type="text"
                  formControlName="amount"
                  mask="separator.2"
                  thousandSeparator=",">
              <div *ngIf="form.amount.errors?.required && showError">
                <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-content mt-3 box-content-size">
        <h5 class="title">
          {{ 'CUSTOMER-REQUEST.CUSTOMER-DETAIL' | translate}}
        </h5>
        <div class="row align-items-start">
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <label for="tax-id" class="required">{{ 'CUSTOMER-REQUEST.TAX-ID' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="tax-id" formControlName="taxID" (input)="taxIDChange($event)">
                <div *ngIf="form.taxID.errors?.required && showError">
                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                </div>
                <div *ngIf="form.taxID.errors?.taxIDInvalid && showError">
                  <span class="text-danger text-left">{{ 'ERROR.INVALID-THAI-TAXID' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <label for="name" class="required">{{ 'CUSTOMER-REQUEST.NAME' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="name" formControlName="name">
                <div *ngIf="form.name.errors?.required && showError">
                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <label for="branch-code">{{ 'CUSTOMER-REQUEST.BRANCH-CODE' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="branch-code" formControlName="branchCode">
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <label for="branch-name">{{ 'CUSTOMER-REQUEST.BRANCH-NAME' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="branch-name" formControlName="branchName">
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <label for="address" class="required">{{ 'CUSTOMER-REQUEST.ADDRESS' | translate}}</label>
              </div>
              <div class="col-12">
                <textarea class="form-control" id="address" rows="4" formControlName="address"></textarea>
                <div *ngIf="form.address.errors?.required && showError">
                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <label for="postcode" [ngClass]="{'required': form.postcode.validator}">{{ 'CUSTOMER-REQUEST.POSTCODE' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="postcode" formControlName="postcode">
                <div *ngIf="form.postcode.errors?.postalCodeInvalid && showError">
                  <span class="text-danger text-left">{{ 'ERROR.INVALID' | translate }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label for="country" class="required">{{ 'CUSTOMER-REQUEST.COUNTRY' | translate}}</label>
              </div>
              <div class="col-12">
                <ng-select class="custom"
                    [items]="countries"
                    labelForId="buyer-country"
                    [bindLabel]="translate.currentLang === 'en' ? 'country_name':'country_name_th'"
                    bindValue="id"
                    placeholder="{{'FILTER.PLACEHOLDER' | translate}}"
                    [clearable]="false"
                    formControlName="country"
                    (change)="countryChange($event)"
                    *ngIf="!refreshDropdown">
                </ng-select>
                <div *ngIf="form.country.errors?.required && showError">
                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <label for="email" class="required">{{ 'CUSTOMER-REQUEST.EMAIL' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="email" formControlName="email">
                <div *ngIf="form.email.errors?.required && showError">
                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                </div>
                <div *ngIf="form.email.errors?.email && showError">
                  <span class="text-danger text-left">{{ 'ERROR.INVALID' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <label for="cc-email">{{ 'CUSTOMER-REQUEST.CC-EMAIL' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="cc-email" formControlName="ccEmail">
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-12">
                <label for="phone-number" class="required">{{ 'CUSTOMER-REQUEST.PHONE-NUMBER' | translate}}</label>
              </div>
              <div class="col-12">
                <input class="form-control" type="text" id="phone-number" formControlName="phoneNumber"
                (keyup)="formatPhoneNumber($event)"
                (keypress)='charValidate($event)'>
                <div *ngIf="form.phoneNumber.errors?.required && showError">
                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="my-4 text-center">
        <div *ngIf="showError && !buyerRequestForm.valid" class="mb-2">
          <span class="text-danger text-left">{{ 'ERROR.TAIL-REPORT' | translate }}</span>
        </div>
        <button class="btn btn-dv btn-wide m-r-5" (click)="confirmation(confirmContent)">
          <i *ngIf="loading" class="fa fa-spinner fa-spin m-r-5"></i>
          {{ 'CUSTOMER-REQUEST.SUBMIT-REQUEST' | translate}}
        </button>
      </div>
    </div>
    <div class="col-md-6 mt-3">
      <div class="box-content mb-3 text-center">
        <img *ngIf="form.type.value === 'dinning'" src="../../../assets/images/sample-abb.png" alt="sample-abb.png"
          class="mr-4 img-pdf">
        <img *ngIf="form.type.value === 'hotel'" src="../../../assets/images/sample-confirmation.png" alt="sample-confirmation.png"
          class="mr-4 img-pdf">
      </div>
    </div>
  </div>
</div>

<ng-template #confirmContent>
  <div class="modal-header">
    <h5 class="modal-title">ขออนุญาตเพื่อเปิดเผยข้อมูล - CONSENT REQUEST</h5>
  </div>
  <div class="modal-body p-y-24 p-x-18">
    <span>ทางโรงแรมสยามเคมปินสกี้ กรุงเทพฯ ขออนุญาตดำเนินการตามสิทธิประโยชน์สำหรับการลดหย่อนภาษีตามประกาศของกรมสรรพากรปี 2567 ทางโรงแรมฯ ใคร่ของความร่วมมือกับแขกผู้ใช้บริการให้ความยินยอมในการเปิดเผยข้อมูลของท่านกับกรมสรรพากร โดยสามารถอ่านรายละเอียดนโยบายความเป็นส่วนตัวเพิ่มเติมที่</span>
    <a href="https://kempinskibangkok.com/Privacy-Policy/E-TAX-PDPA.htm">https://kempinskibangkok.com/Privacy-Policy/E-TAX-PDPA.htm</a>
    <span class="d-block">กรุณากด "ตกลง" เพื่อดำเนินการออกใบกำกับภาษีในลำดับต่อไป</span>
  </div>
  <div class="modal-footer p-y-10">
    <button class="btn btn-dv p-x-18" (click)="submit()">
      <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
      {{ 'COMMON.OK' | translate }}
    </button>
    <button class="btn btn-dv btn-clean" (click)="closeModal()">
      {{ 'COMMON.CLOSE' | translate }}
    </button>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer-request/customer-request.component.html